export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/brand-cb.0cc87139.svg","height":16,"width":26,"blurWidth":0,"blurHeight":0};